import { Grid, Typography, Button } from '@material-ui/core';
import React from 'react';
import sadRobot from '../../assets/sadRobot.png';
import { ErrorPageStyle } from './ErrorPageStyle';

/* Este componente corresponde al template o borrador de las páginas de errores que
se muestran en los distintos paneles. Reciben como parámetro un mensaje a mostrar,
una variable que muestra o no un botón que permite volver a ejecutar una función,
y la función en si. */

interface IErrorTemplateProps {
  readonly message: string | JSX.Element;
  readonly hasReloadButton: boolean;
  readonly reload?: () => void;
}

const ErrorTemplate = ({ message, hasReloadButton, reload = () => {} }: IErrorTemplateProps) => {
  const handleClick = () => reload();
  const classes = ErrorPageStyle();

  return (
    <Grid
      container={true}
      direction="column"
      alignContent="center"
      alignItems="center"
      classes={{ root: classes.displayGrid }}
    >
      <Grid
        item={true}
        container={true}
        direction="column"
        justify="center"
        alignItems="center"
        className={classes.imageAndReloadButtonHeight}
      >
        <Grid item={true}>
          <img src={sadRobot} height="107px" width="99px" alt="Robot" />
        </Grid>
        <Grid item={true} className={classes.marginBetweenMessageAndButton}>
          <Typography variant="h2" className={classes.centerText}>
            {message}
          </Typography>
        </Grid>
        {hasReloadButton ? (
          <Grid item={true}>
            <Button className={classes.errorButton} onClick={handleClick}>
              <Typography className={classes.reloadTypography}>Recargar</Typography>
            </Button>
          </Grid>
        ) : (
          undefined
        )}
      </Grid>
      <Grid
        item={true}
        className={classes.supportContainerHeight}
        container={true}
        direction="column"
        alignItems="center"
        justify="flex-end"
      >
        <Grid item={true}>
          <Typography variant="h5">¿Tienes problemas?</Typography>
        </Grid>
        <Grid item={true}>
          <Typography variant="h5">
            Visite nuestra&nbsp;
            <a
              href="http://soporte.wholemeaning.com/support/home"
              className={classes.linkPurpleColor}
            >
              página de soporte
            </a>
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ErrorTemplate;
